<template>
    <div :style="styles.container" class="event-cards-container">
        <transition name="fade-in">
            <div v-if="eventCancelNotification" class="canceled-event">
                <img :src="getIcon() + 'cancelled-event.png'" />
                <p>Event Cancelled</p>
            </div>
            <div v-if="eventDeleteNotification" class="canceled-event">
                <img :src="getIcon() + 'cancelled-event.png'" />
                <p>Event Deleted</p>
            </div>
        </transition>
        <div
            v-for="(event, indx) in eventsInfo"
            :key="indx"
            :style="styles.card"
            @click="onEventClicked(event)"
            class="event-card-wrapper"
        >
            <div
                v-if="width > 600"
                @click="handleImageClicked(indx, event)"
                class="event-image"
            >
                <img :style="styles.image" :src="eventImage(indx)" alt="event-img" />
            </div>
            <div class="event-details">
                <div class="event-info">
                    <div class="date">
                        <div
                            v-if="width < 600"
                            @click="handleImageClicked(indx, event)"
                            class="event-image"
                        >
                            <img
                                :style="styles.image"
                                :src="eventImage(indx)"
                                alt="event-img"
                            />
                        </div>
                        <p
                            v-if="width > 600"
                            @click="handleDateClicked(indx, event)"
                            :style="styles.date"
                            class="start-date"
                        >
                            {{ eventDate(indx) }}
                        </p>
                        <div v-if="width < 600" class="d-flex flex-column overflow-hidden">
                            <p
                                @click="handleDateClicked(indx, event)"
                                :style="styles.date"
                                class="start-date"
                            >
                                {{ eventDate(indx) }}
                            </p>
                            <div @click="handleNameClicked(indx, event)" class="title">
                                <p :style="styles.title" class="official-title">
                                    {{ eventName(indx) }}
                                </p>
                                <slot name="title-extra" :event="event"></slot>
                            </div>
                        </div>
                        <slot name="date-extra" :event="event"></slot>
                        <p
                            v-if="event.status === 4 && !event.event_type"
                            class="edit-event"
                            @click="goToViewPage(event.id)"
                        >
                            View Event
                        </p>
                        <div
                            ref="event-menus"
                            class="event-settings"
                            v-if="showEventSubMenu(event)"
                            @click="toggleEventMenu(indx, !!!showEventMenu[indx])"
                        >
                            <img v-if="!profile" :src="getIcon() + 'menu-dots.png'" />
                            <div v-if="showEventMenu[indx]" class="event-menu">
                                <p
                                    @click="goToViewPage(event.id)"
                                    v-if="event.event_type === 0 && event.status >= 2"
                                    class="event-menu-setting"
                                >
                                    View event
                                </p>
                                <p
                                    v-if="showActionLinks(event)"
                                    @click="editEvent(event)"
                                    class="event-menu-setting"
                                >
                                    Edit
                                </p>
                                <hr
                                    v-if="showActionLinks(event)"
                                    style="height: 1px; background-color: #888585; margin: 0"
                                />
                                <p
                                    v-if="
                                        showActionLinks(event) &&
                                        event.booked_artists_count > 0
                                    "
                                    class="event-menu-setting cancel-event"
                                    @click="handleModalClicked(indx, event.id)"
                                >
                                    Cancel event
                                </p>
                                <p
                                    v-if="
                                        showActionLinks(event) && !event.booked_artists_count
                                    "
                                    class="event-menu-setting cancel-event"
                                    @click="handleModalClicked(indx, event.id, true)"
                                >
                                    Delete event
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="width > 600"
                        @click="handleNameClicked(indx, event)"
                        class="title"
                    >
                        <p :style="styles.title" class="official-title">
                            {{ eventName(indx) }}
                        </p>
                        <slot name="title-extra" :event="event"></slot>
                    </div>
                    <div :style="styles.info" class="info">
                        <slot name="info-extra" :event="event"></slot>
                    </div>
                </div>
                <div v-if="!profile" class="divider"></div>
                <div class="event-action">
                    <slot name="event-action" :event="event"></slot>
                </div>
            </div>
        </div>
        <b-modal
            no-enforce-focus
            centered
            hide-footer
            id="modal-edit-event"
            size="xl"
            tabindex=""
            content-class="modal-edit-event"
        >
            <template #modal-header>
                <div class="close-modal-filter">
                    <p v-if="currentEvent.status >= 2">Edit Event</p>
                    <p v-else>Edit Opportunity</p>
                    <div @click="$bvModal.hide('modal-edit-event')" class="cancel-btn">
                        <span>Cancel</span>
                        <img :src="getIcon() + 'close-event-modal-yellow.svg'" />
                    </div>
                </div>
            </template>
            <template v-if="currentEvent.status >= 2">
                <EditEventModal @updateEvent="updateEvent" :event.sync="currentEvent" />
            </template>
            <template v-else>
                <EditOpportunityModal @updateEvent="updateEvent" :event="currentEvent" />
            </template>
        </b-modal>
    </div>
</template>
<script>
    import { DAYS, SHORT_MONTHS } from '@/constants/calendar'
    import checkScreen from '../../../mixins/check-screen'
    import EditEventModal from '../modals/EditEventModal.vue'
    import EditOpportunityModal from '../modals/EditOpportunityModal.vue'

    const URLS = {
        images: {
            defaultEventImage: '/images/default-artist-event.png'
        }
    }
    export default {
        name: 'EventCards',
        components: { EditEventModal, EditOpportunityModal },
        mixins: [checkScreen],
        props: {
            eventsInfo: {
                required: true,
                type: Array
            },
            eventClickable: {
                required: false,
                type: Boolean,
                default: false
            },
            renderShortDate: {
                required: false,
                type: Boolean,
                default: false
            },
            eventCancelNotification: {
                type: Boolean
            },
            eventDeleteNotification: {
                type: Boolean
            },
            profile: {
                type: Boolean,
                default: false,
                required: false
            },
            styles: {
                required: false,
                type: Object,
                default: () => ({}),
                validator: (v) => {
                    let keys = Object.keys(v)

                    if (keys.length === 0) return true

                    return keys.some((k) =>
                        ['container', 'date', 'image', 'title'].includes(k)
                    )
                }
            }
        },
        data: () => ({
            showEventMenu: [],
            showCancelEventModal: [],
            showDeleteEventModal: [],
            currentEvent: {}
        }),
        emits: [
            'event-image-clicked',
            'event-date-clicked',
            'event-title-clicked',
            'event-modal-clicked',
            'update:eventInfo',
            'updateEventData'
        ],
        computed: {
            URLS: () => URLS,
            eventImage: (self) => (indx) => {
                const defaultUserImage = '/images/global/default.png'

                if (
                    self.eventsInfo[indx].image &&
                    !self.eventsInfo[indx].image.includes(defaultUserImage)
                ) {
                    return self.eventsInfo[indx].image
                } else if (
                    (!self.eventsInfo[indx].image &&
                        !self.eventsInfo[indx].venue.venue_info.main_avatar) ||
                    self.eventsInfo[indx].venue.venue_info.main_avatar.includes(
                        defaultUserImage
                    )
                ) {
                    return self.URLS.images.defaultEventImage
                } else {
                    return self.eventsInfo[indx].venue.venue_info.main_avatar
                }
            },
            eventDate: (self) => (indx) => {
                if (self.eventsInfo[indx].start_date) {
                    if (self.renderShortDate) {
                        return self.getShortDate(self.eventsInfo[indx].start_date)
                    }

                    return self.eventsInfo[indx].start_date
                }

                return 'Add date'
            },
            eventName: (self) => (indx) => {
                if (self.eventsInfo[indx].event_name) {
                    return self.eventsInfo[indx].event_name
                } else if (self.profile && !self.eventsInfo[indx].event_name) {
                    return ''
                } else {
                    return 'Add event title'
                }
            },
            showEventSubMenu: (self) => (event) =>
                event.status !== 4 &&
                event.status !== 5 &&
                event.status !== 6 &&
                (event.event_type === 0 || self.showActionLinks(event))
        },
        methods: {
            clickedDocument(event) {
                const targetElement = this.$refs['event-menus']

                if (!targetElement.some((el) => el.contains(event.target))) {
                    this.hideEventMenus()
                }
            },
            onEventClicked(event) {
                if (this.eventClickable) {
                    window.open(`/event/show/${event.id}`, '_blank')
                }
            },
            getEventStartDate(start) {
                if (!start) return undefined
                return start.split(' ')[0]
            },

            goToViewPage(id) {
                window.location.href = '/event/show/' + id
            },
            showActionLinks(event) {
                const currentDate = new Date(this.getEventStartDate(event.start))
                const today = new Date()
                const isDateValid = currentDate >= today
                const isEqualToday = currentDate.toDateString() === today.toDateString()
                const hiddenLinks = isDateValid || isEqualToday
                return hiddenLinks && event.status !== 3
            },
            updateEvent(data) {
                this.$emit('updateEventData', data)
            },
            editEvent(event) {
                this.currentEvent = event
                this.$bvModal.show('modal-edit-event')
            },
            hideEventMenus() {
                this.showEventMenu.forEach((_, indx) => {
                    this.$set(this.showEventMenu, indx, false)
                })
            },
            toggleEventMenu(index, state) {
                this.hideEventMenus()
                this.$set(this.showEventMenu, index, state)
            },
            getIcon() {
                return '/images/'
            },
            handleModalClicked(index, id, deleteEvent = false) {
                if (deleteEvent) {
                    this.$set(
                        this.showDeleteEventModal,
                        index,
                        !this.showDeleteEventModal[index]
                    )
                    this.$emit('event-modal-clicked-delete', id)
                } else {
                    this.$set(
                        this.showCancelEventModal,
                        index,
                        !this.showCancelEventModal[index]
                    )
                    this.$emit('event-modal-clicked', id)
                }
            },
            handleImageClicked(indx, event) {
                if (event.status < 3) {
                    this.$emit('update:eventInfo', event)
                    if (!this.eventsInfo[indx].image) {
                        this.$emit('event-image-clicked')
                    }
                }
            },
            handleDateClicked(indx, event) {
                if (event.status < 3) {
                    this.$emit('update:eventInfo', event)
                    if (!this.eventsInfo[indx].start_date) {
                        this.$emit('event-date-clicked')
                    }
                    this.$emit('event-date-clicked')
                }
            },
            handleNameClicked(indx, event) {
                if (event.status < 3) {
                    this.$emit('update:eventInfo', event)
                    this.$emit('event-title-clicked')
                }
            },
            getShortDate(d) {
                let dateArr = d.split(',')
                let month = dateArr[0].split(' ')[0]
                let day = dateArr[0].split(' ')[1]
                let date = new Date(d)

                return `${DAYS[date.getDay()]}, ${SHORT_MONTHS[month]} ${this.formatDay(day)}`
            },
            formatDay(day) {
                let dayLen = day.length

                if (day[dayLen - 1] === '1') {
                    return `${day}st`
                } else if (day[dayLen - 1] === '2') {
                    return `${day}nd`
                } else if (day[dayLen - 1] === '3') {
                    return `${day}rd`
                } else {
                    return `${day}th`
                }
            }
        },

        mounted() {
            document.addEventListener('click', this.clickedDocument)
        },

        beforeDestroy() {
            document.removeEventListener('click', this.clickedDocument)
        }
    }
</script>

<style lang="scss">
    @import '../../../../sass/_variables.scss';
    .modal-edit-event {
        padding: 24px 16px 32px 80px;
        gap: 48px;
        border-radius: 30px;
        background: #262626;
    }
    @media (max-width: 600px) {
        .modal-edit-event {
            padding: 0;
            background: black;
            margin-top: 65px;
            gap: 40px;
            border-radius: 0;

            .close-modal-filter {
                p {
                    color: #8b8b8b !important;
                    font-size: 18px !important;
                }
            }
        }
    }
</style>

<style lang="scss" scoped>
    .cancel-modal {
        color: #8b8b8b;
        text-align: center;
        font-family: 'Studio Pro';
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
        text-decoration-line: underline;
        cursor: pointer;
        margin-top: 24px;
    }
    .close-modal-filter {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }
    .close-modal-filter p {
        color: #dedede;
        font-family: 'Instrument Sans';
        font-size: 20px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
        margin-bottom: 0px;
    }
    .close-modal-filter img {
        height: 20px;
        width: 20px;
    }
    .cancel-btn {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        gap: 8px;
        color: #cdeb09;
    }
    .edit-event {
        margin-left: auto;
        font-family: 'Instrument Sans' !important;
        font-style: normal !important;
        font-weight: 600 !important;
        font-size: 20px !important;
        line-height: 120% !important;
        text-align: right !important;
        letter-spacing: -0.02em !important;
        text-decoration-line: underline !important;
        color: #646464 !important;
        cursor: pointer;
    }
    .fade-in-enter-active,
    .fade-in-leave-active {
        transition: opacity 1s;
    }
    .fade-in-enter,
    .fade-in-leave-to {
        opacity: 0;
    }
    .canceled-event {
        display: flex;
        padding: 12px 16px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: 15px;
        background: rgba(186, 135, 255, 0.95);
        backdrop-filter: blur(6px);
    }
    .cancel-event img {
        max-width: 36px;
        max-height: 29px;
    }
    .canceled-event p {
        color: #121212;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 650;
        line-height: 125%;
        margin: 0;
    }
    .event-menu {
        padding: 12px;
        display: inline-flex;
        flex-direction: column;
        gap: 8px;
        border-radius: 8px;
        background: #464646;
        box-shadow: 0 6px 12px -6px rgba(0, 0, 0, 0.5);
        position: absolute;
        right: 25px;
    }
    .event-menu-setting {
        font-size: 14px !important;
        letter-spacing: 0.14px !important;
        line-height: 130% !important;
        cursor: pointer;
        min-width: max-content;
    }
    .event-menu-setting:hover {
        color: #cdeb09 !important;
    }
    .event-menu-setting.cancel-event:hover {
        color: #d188bf !important;
    }
    .event-settings {
        margin-left: auto;
        position: relative;
        cursor: pointer;
    }
    .event-cards-container {
        display: flex;
        flex-direction: column;
        gap: 16px;
        max-width: 1060px;
        min-width: 600px;
        width: 100%;

        .event-card-wrapper {
            max-width: 1050px;
            display: flex;
            border-radius: 15px;
            background: #262626;
            flex-direction: row;

            .event-image {
                img {
                    height: 100%;
                    object-fit: cover;
                    border-radius: 15px 0 0 15px;
                }
            }

            .event-details {
                padding: 20px 25px 25px 25px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                width: 100%;
                max-width: 730px;

                .event-info {
                    display: flex;
                    flex-direction: column;
                    gap: 6px;

                    .date {
                        display: flex;
                        flex-direction: row;
                        align-items: baseline;
                        gap: 15px;

                        p {
                            color: #dedede;
                            font-family: Instrument Sans;
                            font-size: 38px;
                            font-style: normal;
                            font-weight: 500;
                            line-height: 110%;
                            letter-spacing: -0.76px;
                            margin-bottom: 0px;
                            text-wrap: nowrap;
                        }
                    }

                    .title {
                        display: flex;
                        flex-direction: column;
                        gap: 6px;

                        p {
                            color: #dedede;
                            font-family: Instrument Sans;
                            font-size: 26px;
                            font-style: normal;
                            font-weight: 500;
                            line-height: 120%;
                            letter-spacing: -0.52px;
                            margin-bottom: 0px;
                        }
                    }
                }
                .divider {
                    background: #464646;
                    width: 100%;
                    height: 1px;
                    margin-top: 25px;
                    margin-bottom: 25px;
                }
            }
        }
    }
    @media (max-width: 1000px) {
        .event-cards-container .event-card-wrapper .event-image {
            max-width: 54px;
            max-height: 54px;
        }
        .event-cards-container .event-card-wrapper .event-image img {
            max-width: 54px;
            max-height: 54px;
            border-radius: 8px;
        }
        .event-cards-container {
            min-width: inherit;
        }
        .event-cards-container .event-card-wrapper .event-details .event-info .date p {
            font-size: 20px;
        }
        .event-cards-container .event-card-wrapper .event-details .event-info .title p {
            font-size: 20px;
        }
        .event-cards-container .event-card-wrapper .event-details .event-info .date {
            align-items: center;
        }
        .event-cards-container .event-card-wrapper .event-details .divider {
            margin-top: 0;
        }
    }
    @media (max-width: 800px) and (min-width: 600px) {
        .event-details {
            max-width: 500px;
            .date {
                flex-wrap: wrap;
            }
        }
    }
</style>
